import { supabase } from '../lib/supabase';

export const paymentService = {
  // Create payment intent for orders
  async createPaymentIntent(orderData, customerInfo) {
    try {
      const { data, error } = await supabase?.functions?.invoke('create-payment-intent', {
        body: {
          orderData,
          customerInfo
        }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Create payment intent error:', error);
      throw error;
    }
  },

  // Confirm payment after successful payment
  async confirmPayment(paymentIntentId) {
    try {
      const { data, error } = await supabase?.functions?.invoke('confirm-payment', {
        body: { paymentIntentId }
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Confirm payment error:', error);
      throw error;
    }
  },

  // Get user's payment methods
  async getPaymentMethods(userId) {
    try {
      const { data, error } = await supabase
        ?.from('payment_methods')?.select('*')?.eq('user_id', userId)?.eq('is_active', true)?.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Get payment methods error:', error);
      throw error;
    }
  },

  // Get user's orders
  async getOrders(userId, limit = 10) {
    try {
      const { data, error } = await supabase
        ?.from('orders')
        ?.select(`
          *,
          order_items (
            *,
            subscription_plans (name)
          )
        `)
        ?.eq('user_id', userId)
        ?.order('created_at', { ascending: false })
        ?.limit(limit);

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Get orders error:', error);
      throw error;
    }
  },

  // Get user's payment transactions
  async getPaymentTransactions(userId, limit = 10) {
    try {
      const { data, error } = await supabase
        ?.from('payment_transactions')?.select(`*,orders (order_number,total_amount)`)?.eq('user_id', userId)?.order('created_at', { ascending: false })
        ?.limit(limit);

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Get payment transactions error:', error);
      throw error;
    }
  },

  // Get subscription plans
  async getSubscriptionPlans() {
    try {
      const { data, error } = await supabase
        ?.from('subscription_plans')?.select('*')?.eq('is_active', true)?.order('amount', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Get subscription plans error:', error);
      throw error;
    }
  },

  // Get user's active subscription
  async getUserSubscription(userId) {
    try {
      const { data, error } = await supabase
        ?.from('subscriptions')
        ?.select(`
          *,
          subscription_plans (*)
        `)
        ?.eq('user_id', userId)
        ?.eq('status', 'active')
        ?.single();

      if (error && error?.code !== 'PGRST116') throw error;
      return data;
    } catch (error) {
      console.error('Get user subscription error:', error);
      throw error;
    }
  },

  // Format amount for display
  formatAmount(amount, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    })?.format(amount);
  },

  // Format amount in cents
  formatAmountInCents(amount, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    })?.format(amount / 100);
  }
};